module.exports = __webpack_public_path__ + "assets/img/1691589512664_.pic_hd.76371b47.jpg";